export default __webpack_public_path__ + "static/media/avatar-unwaiter_club_bot.8389b92b.png";